import type { PulseCard } from "@/types";

import { sortCards } from "./sortCards";

export interface EditorialSlots {
  featured: (PulseCard | null)[];
  duo: (PulseCard | null)[];
  layeredHeadline: PulseCard | null;
  layeredBottom: (PulseCard | null)[];
  featuredNext: (PulseCard | null)[];
}

/** Rellena n slots secuencialmente desde `cursor`; slots sobrantes quedan null. */
function pullModule(
  ordered: PulseCard[],
  cursor: number,
  count: number,
): { slots: (PulseCard | null)[]; nextCursor: number } {
  const moduleStart = cursor;
  const slots: (PulseCard | null)[] = [];

  for (let i = 0; i < count; i++) {
    const absolute = moduleStart + i;
    slots.push(absolute < ordered.length ? ordered[absolute]! : null);
  }

  const nextCursor =
    ordered.length >= moduleStart + count ? moduleStart + count : ordered.length;

  return { slots, nextCursor };
}

/** Asigna noticias ordenadas por relevancia a los slots del layout. */
export function assignStorySlots(cards: PulseCard[]): EditorialSlots {
  const ordered = sortCards(cards);
  let cursor = 0;

  const featured = pullModule(ordered, cursor, 4);
  cursor = featured.nextCursor;

  const duo = pullModule(ordered, cursor, 2);
  cursor = duo.nextCursor;

  const headlineSlot = pullModule(ordered, cursor, 1);
  cursor = headlineSlot.nextCursor;

  const layeredBottom = pullModule(ordered, cursor, 2);
  cursor = layeredBottom.nextCursor;

  const featuredNext = pullModule(ordered, cursor, 4);

  return {
    featured: featured.slots,
    duo: duo.slots,
    layeredHeadline: headlineSlot.slots[0] ?? null,
    layeredBottom: layeredBottom.slots,
    featuredNext: featuredNext.slots,
  };
}
